import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Pagination } from 'react-bootstrap'

import GradebookHeaders from './GradebookHeaders'
import StudentNames from './StudentNames'
import StudentEntries from './StudentEntries'

export const GradebookTable = props => {
  const {
    totalStudents,
    limit,
    page,
    activities,
    entries,
    coursenum,
    isPercentFormat,
    updateModal,
    fetchModalBody,
    retrieveData,
  } = props

  const lower = limit * page - limit + 1
  const upper = totalStudents >= limit * page ? limit * page : totalStudents

  return (
    <div>
      <div id="gradebook_table_container">
        <div className="student_count">
          Now showing {lower} - {upper} of {totalStudents} students
        </div>
        <div className="gradebook_table">
          <table className="gradebook_table">
            <tbody>
              <GradebookHeaders activities={activities} coursenum={coursenum} />
              <tr id="gradebook_bottom">
                <td>
                  <div id="gradebook_bottom_left">
                    <StudentNames entries={entries} coursenum={coursenum} />
                  </div>
                </td>
                <td>
                  <div id="gradebook_bottom_right">
                    <StudentEntries
                      activities={activities}
                      entries={entries}
                      isPercentFormat={isPercentFormat}
                      updateModal={updateModal}
                      fetchModalBody={fetchModalBody}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <Pagination
          prev={<span className="text-dark">« Prev</span>}
          next={<span className="text-dark">Next »</span>}
          ellipsis
          boundaryLinks
          maxButtons={5}
          items={Math.ceil(totalStudents / limit)}
          activePage={page}
          onSelect={retrieveData}
        />
      </div>
    </div>
  )
}

GradebookTable.propTypes = {
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  retrieveData: PropTypes.func.isRequired,
  totalStudents: PropTypes.number.isRequired,
  entries: PropTypes.array.isRequired,
  activities: PropTypes.array.isRequired,
  coursenum: PropTypes.string.isRequired,
  isPercentFormat: PropTypes.bool.isRequired,
  updateModal: PropTypes.func.isRequired,
  fetchModalBody: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    totalStudents: state.gradebook.totalStudents,
    activities: state.gradebook.activities,
    entries: state.gradebook.entries,
  }
}

export default connect(mapStateToProps)(GradebookTable)
